export type TFingerprintWindow = Window & {
  Fingerprint?: { get: (options: any, func: (data: string) => void) => void }
}

export const getFingerPrint = (force: Boolean) => {
  if (!force) {
    const fingerPrint = localStorage.getItem("fingerprint")
    if (fingerPrint)
      return fingerPrint
  }

  const fingerprintWindow: TFingerprintWindow = window
  
  if (fingerprintWindow.Fingerprint) {
    fingerprintWindow.Fingerprint.get({ debug: true }, (data) => {
      if (data) {
        localStorage.setItem("fingerprint", btoa(data))
      }
    })
  }

  return localStorage.getItem("fingerprint")
}